__turbopack_context__.v({
  "accordion": "_8D38na_accordion",
  "accordionContent": "_8D38na_accordionContent",
  "accordionHeader": "_8D38na_accordionHeader",
  "address": "_8D38na_address",
  "appStoreButtonsRow": "_8D38na_appStoreButtonsRow",
  "bottomBar": "_8D38na_bottomBar",
  "bottomBarHeading": "_8D38na_bottomBarHeading",
  "bottomBarSection": "_8D38na_bottomBarSection",
  "columnSeparator": "_8D38na_columnSeparator",
  "contactInfo": "_8D38na_contactInfo",
  "contactLink": "_8D38na_contactLink",
  "contentWrapper": "_8D38na_contentWrapper",
  "copyrightRow": "_8D38na_copyrightRow",
  "copyrightText": "_8D38na_copyrightText",
  "dark": "_8D38na_dark",
  "desktopSections": "_8D38na_desktopSections",
  "findStoreLink": "_8D38na_findStoreLink",
  "footerColumnWrapper": "_8D38na_footerColumnWrapper",
  "footerColumnsGrid": "_8D38na_footerColumnsGrid",
  "footerUtilityRow": "_8D38na_footerUtilityRow",
  "footerWrapper": "_8D38na_footerWrapper",
  "hsaFsaBadgeWrapper": "_8D38na_hsaFsaBadgeWrapper",
  "light": "_8D38na_light",
  "linksList": "_8D38na_linksList",
  "mobileSections": "_8D38na_mobileSections",
  "newBadge": "_8D38na_newBadge",
  "regionSelectorWrapper": "_8D38na_regionSelectorWrapper",
  "sectionHeading": "_8D38na_sectionHeading",
  "socialIconsRow": "_8D38na_socialIconsRow",
  "styledLink": "_8D38na_styledLink",
  "wordmarkContainer": "_8D38na_wordmarkContainer",
});
